module.exports = __webpack_public_path__ + "static/media/canaanite_text_06.b28ec765.jpg";